import { SendSmsReq, SendSmsResp } from "../SendSms/SendSms.model";
import { apiService } from "../../../../../services/apiService";
import { utilService } from "../../../../../services/utilService";
import { apiServiceConstants } from "../../../../../constants/apiService.constants";


const sendSmstoSelectedDoctor = async (
  params: SendSmsReq
): Promise<SendSmsResp> => {
  const respApiResult = await apiService
    .apiCall(
      `user/connect/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const submitScheduleListResp = res as SendSmsResp;
      const result: SendSmsResp = {
        isSuccess: true,
        status: submitScheduleListResp.status,
        message: submitScheduleListResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: SendSmsResp = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const sendSmstoUnAssignedNumber = async (params: any): Promise<SendSmsResp> => {
  const respApiResult = await apiService
    .apiCall(
      `user/group-sms/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const submitScheduleListResp = res as SendSmsResp;
      const result: SendSmsResp = {
        isSuccess: true,
        status: submitScheduleListResp.status,
        message: submitScheduleListResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: SendSmsResp = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const getSmsHistoryDetails = async (params: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `user/chat-history/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const submitScheduleListResp = res as any;
      const result: any = {
        isSuccess: true,
        status: submitScheduleListResp.status,
        message: submitScheduleListResp.message,
        result: mapHistoryDetailsData(submitScheduleListResp.result),
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const mapHistoryDetailsData = (payload: any) => {
  let smsHistoryListArray = payload.map((object: any) => {
    return {
      count: object.count,
      data: mapHistoryData(object.data),
      next: object.next,
      previous: object.previous,
    };
  });
  return smsHistoryListArray;
};

const mapHistoryData = (data: any) => {
  var historyObject: any;
  if (data == null) {
    return [];
  } else {
    let historyArray: Array<any> = [];
    data.map((items: any) => {
      historyObject = {
        message: items.message,
        created_on: items.created_on,
        request_type: items.request_type,
        is_media: items.is_media,
        media_data: items.media_data,
        media_disposal_info: items.media_disposal_info,
        isExpired: items.is_expired
      };
      historyArray.push(historyObject);
    });
    return historyArray;
  }
};

const handleErrorResponse = () => {};

export const sendSmsServive = {
  sendSmstoSelectedDoctor,
  handleErrorResponse,
  sendSmstoUnAssignedNumber,
  getSmsHistoryDetails,
};
